const fullEleInvoiceIsAbnormalConfig = {
    version: 5.5,
    queryForm: [
        {
            // 0
            label: '异常类型',
            selected: true,
            default: true,
            name: 'operationType',
            type: 'dict',
            dict: 'operation_type',
        },
        {
            label: '单据编号',
            selected: true,
            default: true,
            name: 'billCode',
        },
        {
            label: '销方名称',
            selected: true,
            default: true,
            name: 'saleName',
        },
        {
            //5
            label: '创建时间',
            selected: false,
            default: false,
            name: 'createTime',
            type:'date'
        },
        {
            label: '事业部',
            selected: false,
            default: false,
            name: 'departmentNo',
            dict: 'department_no',
            type: 'dict',
        },
        {
            label: '主管税局省市',
            selected: false,
            default: false,
            name: 'taxBureauId',
            // name: 'province',
            type: 'taxBureauId',
        },
        {
            //10
            label: '发票种类',
            selected: false,
            default: false,
            name: 'invoiceType',
            type: 'dict',
            dict: 'pool_inv_type',
        },
        {
            label: '特定业务类型',
            selected: false,
            default: false,
            name: 'specificElements',
            type: 'dict',
            dict: 'specific_element',
        },
        {
            label: '数电票号码',
            selected: false,
            default: false,
            name: 'electricInvoiceNum',
        },
        {
            label: '发票状态',
            selected: false,
            default: false,
            name: 'invoiceStatus',
            type: 'dict',
            dict: 'invoice_status',
        },
        {
            label: '下载状态',
            selected: false,
            default: false,
            name: 'isDownload',
            type: 'dict',
            dict: 'is_download',
        },
        {
            label: '交付状态',
            selected: false,
            default: false,
            name: 'sendStatus',
            type: 'dict',
            dict: 'send_status',
        },
        {
            label: '所属大区',
            selected: false,
            default: false,
            name: 'regionNo',
            type: 'regionNo',
        },
        {
            label: '开票员',
            selected: false,
            default: false,
            name: 'realName',
        },
        {
            label: '数据来源',
            selected: false,
            default: false,
            name: 'invoiceSource',
            type: 'dict',
            dict: 'invoice_source',
        },
        {
            label: '异常原因',
            selected: false,
            default: false,
            name: 'errorMessage',
        },
    ],
    table: [
        {
            label: '异常原因',
            selected: true,
            default: true,
            name: 'errorMessage',
            sort: true,
        },
        {
            label: '异常类型',
            selected: true,
            default: true,
            name: 'operationType',
            sort: true,
            type: 'dict',
            dict: 'operation_type',
        },
        {
            label: '开票方式',
            selected: true,
            default: true,
            name: 'manageType',
            sort: true,
            type: 'dict',
            dict: 'manage_type',
        },
        {
            label: '单据编号',
            selected: true,
            default: true,
            name: 'billCode',
            sort: true,
        },
        {
            label: '销方名称',
            selected: true,
            default: true,
            name: 'saleName',
            sort: true,
        },
        {
            label: '销方税号',
            selected: true,
            default: true,
            name: 'saleCreditCode',
            sort: true,
        },
        {
            label: '开票员',
            selected: true,
            default: true,
            name: 'realName',
            sort: true,
        },
        {
            //5
            label: '创建时间',
            selected: true,
            default: true,
            name: 'createTime',
            sort: true,
        },
        {
            label: '数据来源',
            selected: false,
            default: false,
            sort: true,
            name: 'invoiceSource',
            type: 'dict',
            dict: 'invoice_source',
        },
        {
            label: '事业部',
            selected: false,
            default: false,
            name: 'departmentNo',
            dict: 'department_no',
            type: 'dict',
        },
        {
            label: '所属区域',
            selected: false,
            default: false,
            sort: true,
            name: 'regionName',
        },
        {
            label: '城市',
            selected: false,
            default: false,
            sort: true,
            name: 'cityName',
        },
        {
            label: '主管税局省市',
            selected: false,
            default: false,
            sort: true,
            name: 'taxBuName',
        },
        {
            //10
            label: '合计金额',
            sort: true,
            selected: true,
            default: true,
            name: 'totalAmt',
        },
        {
            label: '合计税额',
            sort: true,
            selected: true,
            default: true,
            name: 'totalTaxamt',
        },
        {
            label: '价税合计',
            sort: true,
            selected: false,
            default: false,
            name: 'adValoremTotal',
        },
        {
            label: '发票种类',
            selected: false,
            default: false,
            sort: true,
            name: 'invoiceType',
            type: 'dict',
            dict: 'pool_inv_type',
        },
        {
            label: '特定业务类型',
            selected: false,
            default: false,
            sort: true,
            name: 'specificElements',
            type: 'dict',
            dict: 'specific_element',
        },
        {
            label: '购方名称',
            selected: true,
            default: true,
            sort: true,
            name: 'custName',
        },
        {
            label: '购方税号',
            selected: true,
            default: true,
            sort: true,
            name: 'custCreditCode',
        },
        {
            label: '数电票号码',
            selected: false,
            default: false,
            sort: true,
            name: 'electricInvoiceNum',
        },
        {
            label: '发票代码',
            selected: false,
            default: false,
            sort: true,
            name: 'invoiceCode',
        },
        {
            label: '发票号码',
            selected: false,
            default: false,
            sort: true,
            name: 'invoiceNumber',
        },
        {
            label: '开票日期',
            selected: false,
            default: false,
            sort: true,
            name: 'invoiceDate',
        },
        {
            label: '发票状态',
            selected: false,
            default: false,
            sort: true,
            name: 'invoiceStatus',
            type: 'dict',
            dict: 'invoice_status',
        },
        {
            label: '下载状态',
            selected: false,
            default: false,
            sort: true,
            name: 'isDownload',
            type: 'dict',
            dict: 'is_download',
        },
        {
            label: '交付状态',
            selected: false,
            default: false,
            name: 'sendStatus',
            type: 'dict',
            dict: 'send_status',
            sort: true,
        },
        {
            label: '邮箱',
            selected: false,
            default: false,
            name: 'custEmail',
            sort: true,
        },
        {
            label: '手机号',
            selected: false,
            default: false,
            name: 'custMobile',
            sort: true,
        },
        {
            label: '备注',
            selected: false,
            default: false,
            name: 'remark',
            sort: true,
        },
        {
            label: '发票id',
            selected: false,
            default: false,
            name: 'invoiceId',
            sort: true,
        },
    ],
}

export default fullEleInvoiceIsAbnormalConfig



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/fullEleInvoiceIsAbnormal/fieldConfig.js